import { mix } from 'mixwith/mixwith';
import { of, map } from 'rxjs';

import LocationTally from './LocationTally';
import locationNameMixin from './mixins/locationNameMixin';

class CategoryTally extends mix(LocationTally).with(locationNameMixin) {
  static fromObject(data, name = '') {
    return new CategoryTally(data, name);
  }

  /**
   *
   * @param data
   * @param name
   * @returns {Observable<CategoryTally>}
   */
  static fromObjectObservable(data, name = '') {
    const observable = of(data)
      .pipe(map((category) => CategoryTally.fromObject(category, name)));

    return observable;
  }
}

export default CategoryTally;
